import {BaseMuWidget} from "../BaseMuWidget";

export class AccountLink extends BaseMuWidget
{
	// @ts-ignore
	public accountName: string;
	// @ts-ignore
	public accountId: number;

	beforeIndex() {
		this.container.classList.add("icon-before-person");
	}

	update() {
		// @ts-ignore
		this.container.innerText = this.accountName;
	}

	afterIndex() { this.update(); }

	protected muAfterBindData(data: any) { this.update(); }
}